import { render, staticRenderFns } from "./ProviderTable.vue?vue&type=template&id=0ed7b12b"
import script from "./ProviderTable.vue?vue&type=script&lang=js"
export * from "./ProviderTable.vue?vue&type=script&lang=js"
import style0 from "./ProviderTable.vue?vue&type=style&index=0&id=0ed7b12b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports